<template>
	<div>
		<p class="step-title mb-4">
			{{$t('account/bookings.Resume')}}
		</p>

		<resume-template 
		class="col-md-10 mx-auto mb-5"/>

		<div class="row col-md-10 mx-auto mb-5">

			<resume-informations 
			class="col-md-6" />

			<resume-documents
			class="col-md-6" />

		</div> <!-- /.row -->

	</div>
</template>

<script>

	import ResumeTemplate from '@components/booking/resume/Template'
	import ResumeInformations from '@components/booking/resume/Informations'
	import ResumeDocuments from '@components/booking/resume/Documents'

	export default {

		components: {
			ResumeTemplate,
			ResumeInformations,
			ResumeDocuments
		},

		methods: {

			checkComplete() {
				return true
			}

		}

	}
</script>